<template>
  <div class="test">
    <UserForm v-show="activeStep === 0 && !testCompleted" />

    <div v-show="activeStep > 0 && !testCompleted" :class="stepClass">
      <p class="description">
        In diesem Test werden auf jeder Seite sechs verschiedene Tätigkeiten angezeigt. Wähle einmal Daumen hoch für die Tätigkeit, die dich am meisten interessiert und einmal Daumen runter für das, was dich am wenigsten interessiert.
      </p>
      <transition-group name="slide">
        <Card
          v-for="(items, key) in structure"
          :key="key"
          v-show="activeStep == key"
          :items="items"
        />
      </transition-group>
    </div>

    <div v-show="testCompleted" class="finished">
      <h3 class="headline">Fertig!</h3>
      <p class="description">Du hast es geschafft! In Kürze senden wir die Testauswertung an die angegebene E-Mail-Adresse.</p>
      <p class="description">Das Team von<br>Fuchs Konzepte</p>
    </div>
  </div>
</template>

<script>
import UserForm from '@/components/UserForm'
import Card from '@/components/Card'

export default {
  name: 'Test',
  components: {
    UserForm,
    Card,
  },
  computed: {
    activeStep() {
      return this.$store.state.activeStep
    },
    stepClass() {
      return `steps step-${this.$store.state.activeStep}`
    },
    testCompleted() {
      return this.$store.state.testCompleted
    },
    regions() {
      return this.$store.state.regions
    },
    structure() {
      return this.$store.state.structure
    },
    activeQuestion() {
      return this.$store.getters.activeQuestion || null
    },
  },
}
</script>

<style>
code {
  text-align: center;
  background-color: #eee;
  padding: 5px;
  width: 100%;
}

.test {
  margin: 0 15px;
  padding: 30px;
  background-color: white;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  transition: 0.2s;
  text-align: center;
  position: relative;
}

.headline {
  margin: 0 0 1em 0;
  color: #ec7404;
}

.description {
  max-width: 550px;
  margin: 0 auto 30px auto;
}

.actions {
  background-color: #ddd;
  margin-top: auto;
  display: flex;
  margin: 50px -30px -30px -30px;
  border-radius: 0 0 2px 2px;
}

button {
  border: 0;
  background-color: transparent;
  flex: 1;
  padding: 8px;
  cursor: pointer;
  text-align: center;
}

button:disabled {
  cursor: not-allowed;
}

.actions button {
  font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  text-transform: uppercase;
  color: #ec7404;
  letter-spacing: 0.2em;
  padding: 14px 30px;
  font-weight: 700;
  transition: 0.2s;
}

.actions button:hover {
  color: white;
  background-color: #ec7404;
}

.actions button:disabled,
.actions button:disabled:hover {
  color: #9b9b9b;
  background-color: transparent;
}

.actions button.prev {
  text-align: left;
}

.actions button.next {
  text-align: right;
}

.slide-enter-active {
  transition: 0.5s;
}

.slide-enter {
  opacity: 0;
  visibility: hidden;
  display: block;
}

.slide-enter-to,
.slide-leave {
  opacity: 1;
  visibility: visible;
}

.slide-leave-active {
  display: none;
}

.slide-leave-to {
  opacity: 0;
  visibility: hidden;
}
</style>
